// import { push } from "connected-react-router";
import * as types from "./actionTypes";
import { hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import { toggleLoader } from "./loaderActions";
import taskService from "../services/taskService";

export function loadTaskSuccess(tasks) {
  return {
    type: types.LOAD_TASK_SUCCESS,
    tasks,
    meta: {
      throttle: true
    }
  };
}

export function getTaskSuccess(task) {
  return {
    type: types.GET_TASK_SUCCESS,
    task
  };
}

export function savingTask(status = true) {
  return {
    type: types.SAVING_TASK,
    savingTask: status
  };
}

export function createTaskSuccess(task) {
  return {
    type: types.CREATE_TASK_SUCCESS,
    task
  };
}

export function updateTaskSuccess(task) {
  return {
    type: types.UPDATE_TASK_SUCCESS,
    task
  };
}

export function loadTasks() {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return taskService
      .loadTasks()
      .then(async (data) => {
        await dispatch(loadTaskSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function getTask(id) {
  return (dispatch) =>
    taskService
      .getTask(id)
      .then((task) => {
        dispatch(getTaskSuccess(task));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createTask(task) {
  return (dispatch) => {
    dispatch(savingTask());
    return taskService
      .createTask(task)
      .then((createdTask) => {
        dispatch(createTaskSuccess(createdTask));
        dispatch(savingTask(false));
        dispatch(showAlertSuccess("Task created successfully", "success"));
        dispatch(hideModalSuccess("taskModal"));
      })
      .catch((error) => {
        dispatch(savingTask(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateTask(task) {
  return (dispatch) => {
    dispatch(savingTask());
    return taskService
      .updateTask(task)
      .then((updatedTask) => {
        dispatch(updateTaskSuccess(updatedTask));
        dispatch(savingTask(false));
        dispatch(hideModalSuccess("taskModal"));
        dispatch(showAlertSuccess("Task updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingTask(false));
        dispatch(showAlertSuccess(error, "error"));
      });
  };
}
